import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { place_order } from "../store/reducers/orderReducer";
import { NumericFormat } from "react-number-format";
import ConfirmationModal from "../components/shared/ConfirmationModal";
import { useEffect } from "react";

const Shipping = () => {
  const {
    state: { products, price, shipping_fee, items },
  } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Add handleConfirmOrder
  const handleConfirmOrder = () => {
    setIsModalOpen(true);
  };

  const [res, setRes] = useState(false);
  const [state, setState] = useState({
    name: "",
    address: "",
    phone: "",
    province: "",
    city: "",
  });

  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const save = (e) => {
    e.preventDefault();
    const { name, address, phone, province, city } = state;
    if (name && address && phone && province && city) {
      setRes(true);
    }
  };

  const placeOrder = async () => {
    setIsProcessing(true);
    try {
      dispatch(
        place_order({
          price,
          products,
          shipping_fee,
          items,
          shippingInfo: state,
          userId: userInfo.id,
          navigate,
        })
      );
    } finally {
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <section className='bg-[url("https://diarcel.com/images/banner/shop.png")] h-[220px] bg-cover bg-no-repeat relative bg-left'>
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Confirmar Pedido </h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to="/">Inicio</Link>
                <span className="pt-1">
                  <IoIosArrowForward />
                </span>
                <span>Confirmación </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#eeeeee]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16">
          <div className="w-full flex flex-wrap">
            <div className="w-full md:w-[67%]">
              <div className="flex flex-col gap-3">
                <div className="bg-white p-6 shadow-sm rounded-md">
                  <h2 className="text-slate-600 font-bold pb-3">
                    Información de Envio
                  </h2>

                  {!res && (
                    <>
                      <form onSubmit={save}>
                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="name"> Nombre </label>
                            <input
                              onChange={inputHandle}
                              value={state.name}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-600 rounded-md"
                              name="name"
                              id="name"
                              placeholder="Nombre"
                            />
                          </div>

                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="address"> Dirección </label>
                            <input
                              onChange={inputHandle}
                              value={state.address}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-600 rounded-md"
                              name="address"
                              id="address"
                              placeholder="Dirección"
                            />
                          </div>
                        </div>

                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="phone"> Teléfono </label>
                            <input
                              onChange={inputHandle}
                              value={state.phone}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-600 rounded-md"
                              name="phone"
                              id="phone"
                              placeholder="Teléfono"
                            />
                          </div>

                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="province"> Aldea </label>
                            <input
                              onChange={inputHandle}
                              value={state.province}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-600 rounded-md"
                              name="province"
                              id="province"
                              placeholder="Aldea"
                            />
                          </div>
                        </div>

                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="city"> Municipio </label>
                            <input
                              onChange={inputHandle}
                              value={state.city}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-600 rounded-md"
                              name="city"
                              id="city"
                              placeholder="Municipio"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mt-7 mb-2 w-full">
                            <button className="px-3 py-[6px] rounded-md hover:shadow-green-600/50 hover:shadow-lg bg-green-600 text-white">
                              Guardar Cambios
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  )}

                  {res && (
                    <div className="flex flex-col gap-1">
                      <h2 className="text-slate-600 font-semibold pb-2">
                        Enviar a {state.name}
                      </h2>
                      <div className="border p-2 rounded-md">
                        <span className="bg-blue-200 text-blue-800 text-sm font-medium mr-2 px-2 py-1 rounded">
                          {state.name}
                        </span>
                        <div>
                          {state.city} {state.province}, {state.address}
                        </div>
                        <span>
                          {state.phone}
                          {state.area}{" "}
                        </span>

                        <div className="flex text-indigo-500">
                          <div
                            className="cursor-pointer"
                            onClick={() => setRes(false)}
                          >
                            Cambiar
                          </div>
                        </div>
                      </div>

                      <p className="text-slate-600 text-sm">
                        Enviar correo electronico a {userInfo.email}
                      </p>
                    </div>
                  )}
                </div>

                {products.map((p, i) => (
                  <div
                    key={i}
                    className="flex bg-white p-4 flex-col gap-2 rounded-md"
                  >
                    <div className="flex justify-start items-center">
                      <h2 className="text-md text-slate-600 font-bold">
                        {p.shopName}
                      </h2>
                    </div>

                    {p.products.map((pt, i) => (
                      <div className="w-full flex flex-wrap my-2" key={i}>
                        <div className="flex sm:w-full gap-2 w-7/12">
                          <div className="flex gap-2 justify-start items-center">
                            <img
                              className="w-[80px] h-[80px] rounded-lg"
                              src={pt.productInfo.images[0]}
                              alt=""
                            />
                            <div className="pr-4 text-slate-600">
                              <h2 className="text-md font-semibold">
                                {pt.productInfo.name}{" "}
                              </h2>
                              <span className="text-sm">
                                Marca: {pt.productInfo.brand}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="flex justify-between w-5/12 sm:w-full sm:mt-3">
                          <div className="pl-4 sm:pl-0">
                            <div>
                              <NumericFormat
                                className="text-lg text-slate-500"
                                displayType="text"
                                value={
                                  pt.productInfo.price -
                                  (pt.productInfo.price *
                                    pt.productInfo.discount) /
                                    100
                                }
                                placeholder="Precio"
                                thousandSeparator=","
                                decimalScale={2}
                                fixedDecimalScale
                                prefix={"L "}
                                allowNegative={false}
                              />
                            </div>
                            {pt.productInfo.discount ? (
                              <>
                                <div>
                                  <NumericFormat
                                    className="line-through text-red-400"
                                    displayType="text"
                                    value={pt.productInfo.price}
                                    placeholder="Precio"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix={"L "}
                                    allowNegative={false}
                                  />
                                </div>
                                <span className="text-orange-500">
                                  Rebaja {pt.productInfo.discount.toFixed(2)}%
                                </span>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full md:w-[33%]">
              <div className="pl-0 mt-3 md:m-0 md:pl-3">
                <div className="bg-white p-3 text-slate-600 flex flex-col gap-3  rounded-md">
                  <h2 className="text-xl font-bold">Resúmen de la Orden</h2>
                  <div className="flex justify-between items-center">
                    <span>Subtotal </span>
                    <span>
                      <NumericFormat
                        displayType="text"
                        value={price}
                        thousandSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        prefix={"L "}
                      />
                    </span>
                  </div>

                  <div className="flex justify-between items-center">
                    <span>ISV </span>
                    <span>
                      <NumericFormat
                        displayType="text"
                        value={price * 0.15}
                        thousandSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        prefix={"L "}
                      />
                    </span>
                  </div>

                  <div className="flex justify-between items-center">
                    <span>Total </span>
                    <span>
                      <NumericFormat
                        displayType="text"
                        value={price + price * 0.15}
                        thousandSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        prefix={"L "}
                      />
                    </span>
                  </div>

                  <div className="flex justify-between items-center">
                    <span>Envio </span>
                    <span>L 0.00 </span>
                  </div>

                  <div className="flex justify-between items-center">
                    <span>Total a Pagar</span>
                    <span className="text-lg text-[#059473]">
                      <NumericFormat
                        displayType="text"
                        value={price + price * 0.15}
                        thousandSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        prefix={"L "}
                      />
                    </span>
                  </div>
                  <button
                    onClick={handleConfirmOrder}
                    disabled={res ? false : true}
                    className={`px-5 py-[6px] rounded-md ${
                      res
                        ? "hover:shadow-blue-500/50 hover:shadow-lg bg-blue-500"
                        : "bg-blue-300"
                    } text-sm text-white uppercase`}
                  >
                    Confirmar Orden
                  </button>

                  <ConfirmationModal
                    isOpen={isModalOpen}
                    setIsOpen={setIsModalOpen}
                    isLoading={isProcessing}
                    onConfirm={placeOrder}
                    title="Confirmar Pedido"
                    description={`¿Estás seguro de realizar este pedido?`}
                    confirmText="Procesar Pedido"
                    cancelText="Cancelar"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Shipping;
